import RetinaImage from 'react-retina-image';
import React, {PropTypes} from 'react';

export default function CharacterSymbol({source}) {
  return (
    <div>
      <RetinaImage src={[require(`../images/${source}.png`), require(`../images/${source}@2x.png`)]} />
    </div>
  );
}

CharacterSymbol.propTypes = {
  source: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./app/features/shared/components/CharacterSymbol.js